import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MaterialModule } from '../../../material.module';
import { ContentModule } from '@alfresco/adf-content-services';
import { EXTENSION_DIRECTIVES } from '@alfresco/adf-extensions';
import { NodeChildAssociationEntry } from '@alfresco/js-api';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@adw/projects/aca-shared/src/public-api';

import {
  CancelSessionOfficeAction,
  EndSessionOfficeAction,
} from '../../store/actions/extension.actions';
import { AppStore } from '../../../store/states';

@Component({
  selector: 'wk-end-session-dialog',
  standalone: true,
  templateUrl: './end-session-dialog.component.html',
  styleUrls: ['./end-session-dialog.component.scss'],
  imports: [
    FormsModule,
    TranslateModule,
    CommonModule,
    ...EXTENSION_DIRECTIVES,
    SharedModule,
    ContentModule,
    MaterialModule,
    A11yModule,
  ],
})
export class EndSessionDialogComponent {
  public node: NodeChildAssociationEntry;
  public version: 'minor' | 'major' = 'minor';
  public comment = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private readonly dialogRef: MatDialogRef<EndSessionDialogComponent>,
    private readonly store: Store<AppStore>
  ) {
    this.node = data.node;
  }

  // Dispatches an action to end the session and closes the dialog
  public endSession(): void {
    this.store.dispatch(
      new EndSessionOfficeAction({
        node: this.node,
        isMajor: this.version === 'major',
        comment: this.comment,
      })
    );
    this.dialogRef.close();
  }

  // Dispatches an action to discard the session and closes the dialog
  public discardSession(): void {
    this.store.dispatch(new CancelSessionOfficeAction(this.node));
    this.dialogRef.close();
  }
}
